/**
 * BŁĄD ŁADOWANIA CHUNKU PO WDROŻENIU — funkcje czyste (zamrażalne zapadką).
 *
 * [zgłoszenie właściciela 2026-09-20] „jak czasami długo mnie nie ma, aplikacja wyrzuca błąd
 * techniczny (…) jakbyś coś na hosting wgrywał".
 *
 * CO SIĘ DZIAŁO: strony są dzielone na chunki z nazwą zależną od treści (main.<hash>.js,
 * 8361.<hash>.chunk.js). Karta otwarta PRZED wdrożeniem trzyma stary index.html z listą starych nazw.
 * Po wdrożeniu (skrypt czyścił `frontend/static`) pierwsze wejście na podstronę, której chunk nie był
 * jeszcze pobrany, kończyło się 404 → `ChunkLoadError` → ErrorBoundary pokazywał „Wystąpił nieoczekiwany
 * błąd”. Człowiek widział „wyrzuciło mnie”, choć sesja była w porządku — wystarczyło odświeżyć.
 *
 * NAPRAWA (dwie strony): tu — rozpoznanie tej klasy błędu i JEDNORAZOWE automatyczne przeładowanie
 * (strażnik w sessionStorage, żeby przy realnej awarii nie zapętlić odświeżania); po stronie serwera —
 * wdrożenie nie kasuje już starych chunków od razu (przycinanie po 14 dniach).
 */

/** Klucz strażnika „już raz przeładowano po tym błędzie” — per adres, per karta. */
export const KLUCZ_STRAZNIKA = "mp:przeladowano-po-chunku";

const WZORCE = [
    /ChunkLoadError/i,
    /Loading chunk [\w-]+ failed/i,
    /Loading CSS chunk [\w-]+ failed/i,
    /Failed to fetch dynamically imported module/i,
    /Importing a module script failed/i,
    /error loading dynamically imported module/i,
];

/** Czy to błąd pobrania kawałka aplikacji (stara karta po wdrożeniu), a nie błąd logiki ekranu. */
export function czyBladChunku(blad) {
    if (!blad) return false;
    const nazwa = String(blad.name || "");
    const tresc = String(blad.message || blad);
    return nazwa === "ChunkLoadError" || WZORCE.some((w) => w.test(tresc));
}

/**
 * Jednorazowe przeładowanie po błędzie chunku. Zwraca `true`, gdy przeładowanie zostało zlecone,
 * `false`, gdy dla tego adresu już raz przeładowano (wtedy błąd ma się pokazać normalnie).
 * @param {object} [okno] — `window` (podmienialne w testach)
 */
export function przeladujPoBledzieChunku(okno = typeof window !== "undefined" ? window : null) {
    if (!okno) return false;
    const adres = `${okno.location?.pathname || ""}${okno.location?.search || ""}`;
    let poprzedni = null;
    try { poprzedni = okno.sessionStorage?.getItem(KLUCZ_STRAZNIKA); } catch { /* prywatne okno */ }
    if (poprzedni === adres) return false;
    try { okno.sessionStorage?.setItem(KLUCZ_STRAZNIKA, adres); } catch { /* bez strażnika i tak przeładuj raz */ }
    okno.location.reload();
    return true;
}

/** Po udanym wejściu na stronę strażnik ma zniknąć — następne wdrożenie znów dostanie jedno przeładowanie. */
export function zdejmijStraznikaChunku(okno = typeof window !== "undefined" ? window : null) {
    try { okno?.sessionStorage?.removeItem(KLUCZ_STRAZNIKA); } catch { /* nic */ }
}
